import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {EmployeeDetailsReportData} from "./employee-details-report.data";

@Injectable()
export class EmployeeDetailsReportModel extends ReportModel<EmployeeDetailsReportData> {
    constructor(injector: Injector) {
        super(injector, EmployeeDetailsReportData);
    }
}
